import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/alcoholes/';

/**
 * GET Alcohols
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAlcoholes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Alcohol
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getAlcohol = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Alcohol
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postAlcohol = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Alcohol
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchAlcohol = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Alcohol
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteAlcohol = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Alcohol
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosAlcohol = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Alcohol para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAlcoholCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/alcohol-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
